import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = { class: "mb-4 mt:mb-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", {
  for: "subscription",
  class: "block mb-2 text-2xl font-medium text-gray-900"
}, "Subscription", -1)
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "overflow-x-auto" }
const _hoisted_6 = { class: "text-lg font-bold" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-700" }, "Bookings the User has made for themselves, or has been booked onto by others (i.e via License orders)", -1)
const _hoisted_8 = { class: "w-full table-auto" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "font-bold text-left border-b-2 border-black" }, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "w-64 px-2 py-2"
    }, "Event Name"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-2 py-2"
    }, "Type"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-2 py-2"
    }, "Course Type"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-2 py-2"
    }, "Location"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-2 py-2"
    }, "Delivery Date"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-2 py-2"
    }, "Trainer"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-2 py-2"
    }, "Status"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-2 py-2"
    }, "Actions")
  ])
], -1)
const _hoisted_10 = { class: "w-64 px-4 py-6 capitalize md:py-3" }
const _hoisted_11 = { class: "px-4 py-2 capitalize" }
const _hoisted_12 = { class: "px-4 py-2 capitalize md:px-2" }
const _hoisted_13 = { class: "px-4 py-2 capitalize" }
const _hoisted_14 = { class: "px-4 py-2 capitalize md:px-2" }
const _hoisted_15 = {
  key: 0,
  class: "px-4 py-2 capitalize"
}
const _hoisted_16 = {
  key: 1,
  class: "px-4 py-2 capitalize"
}
const _hoisted_17 = {
  key: 2,
  class: "px-4 py-2 capitalize"
}
const _hoisted_18 = {
  key: 3,
  class: "px-4 py-2 capitalize"
}
const _hoisted_19 = { class: "px-4 py-2 divide-x-2 divide-gray-300" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("td", { class: "p-2" }, "No event bookings found", -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "pt-4 mt-16 overflow-x-auto border-t" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-bold" }, "Licence Orders", -1)
const _hoisted_25 = { class: "w-full table-auto" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "font-bold text-left border-b-2 border-black whitespace-nowrap" }, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-2 py-2"
    }, "Order No."),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-2 py-2"
    }, "Placed"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-2 py-2"
    }, "Organisation"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-2 py-2"
    }, "Level"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-2 py-2"
    }, "Quantity"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-2 py-2"
    }, "Payment Method"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-2 py-2"
    }, "Invoice Issued"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-2 py-2"
    }, "Paid"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-2 py-2"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "hidden" }, "Actions")
    ])
  ])
], -1)
const _hoisted_27 = { class: "px-2 py-6 capitalize md:py-3" }
const _hoisted_28 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_29 = { class: "px-2 py-2 capitalize" }
const _hoisted_30 = { class: "px-2 py-2 capitalize" }
const _hoisted_31 = { class: "px-2 py-2 capitalize" }
const _hoisted_32 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_33 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_34 = {
  key: 0,
  class: "px-2 text-sm text-white rounded-full bg-success w-fit"
}
const _hoisted_35 = {
  key: 1,
  class: "px-2 text-sm text-black rounded-full bg-warning w-fit"
}
const _hoisted_36 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_37 = {
  key: 0,
  class: "px-2 text-sm text-white rounded-full bg-success w-fit"
}
const _hoisted_38 = {
  key: 1,
  class: "px-2 text-sm text-black rounded-full bg-warning w-fit"
}
const _hoisted_39 = { class: "px-4 py-2 divide-x-2 divide-gray-300" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("td", { class: "p-2" }, "No license orders found", -1)
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = { class: "pt-4 mt-16 overflow-x-auto border-t" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-bold" }, "Transactions", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-700" }, "Other transactions the User has made for themselves such as One-off Fee Transactions and Subscriptions", -1)
const _hoisted_46 = { class: "w-full table-auto" }
const _hoisted_47 = { class: "font-bold text-left capitalize border-b-2 border-black divide-x divide-gray-300" }
const _hoisted_48 = {
  scope: "col",
  class: "w-16 px-2 py-2"
}
const _hoisted_49 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_50 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_51 = {
  scope: "col",
  class: "w-48 px-2 py-2"
}
const _hoisted_52 = {
  scope: "col",
  class: "w-48 px-2 py-2"
}
const _hoisted_53 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_54 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_55 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_56 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_57 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_58 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_59 = { class: "px-2 py-3 capitalize" }
const _hoisted_60 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_61 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_62 = { class: "px-2 py-2 capitalize" }
const _hoisted_63 = { class: "px-2 py-2 capitalize" }
const _hoisted_64 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_65 = { class: "px-2 py-2 capitalize" }
const _hoisted_66 = {
  key: 0,
  class: "px-2 text-sm text-white rounded-full bg-success w-fit"
}
const _hoisted_67 = {
  key: 1,
  class: "px-2 text-sm text-black rounded-full bg-warning w-fit"
}
const _hoisted_68 = { key: 0 }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("td", { class: "p-2" }, "No transactions found", -1)
const _hoisted_70 = [
  _hoisted_69
]
const _hoisted_71 = { key: 5 }
const _hoisted_72 = { key: 6 }
const _hoisted_73 = { class: "mt-6 md:mt-0" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("label", {
  for: "subscription",
  class: "block mb-2 text-sm font-medium text-gray-900"
}, "New Note", -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-6 bg-play-light-gray" }, null, -1)
const _hoisted_76 = { class: "mt-8" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("label", {
  for: "subscription",
  class: "block mb-2 text-sm font-medium text-gray-900"
}, "All Notes", -1)
const _hoisted_78 = { key: 0 }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("p", null, "This user has no notes", -1)
const _hoisted_80 = [
  _hoisted_79
]
const _hoisted_81 = { class: "mt-6" }
const _hoisted_82 = { class: "w-full" }
const _hoisted_83 = { class: "flex items-center mx-2 space-x-2 text-sm" }
const _hoisted_84 = { class: "capitalize" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("span", null, "|", -1)
const _hoisted_86 = { class: "flex my-4 md:px-4 md:my-0 md:items-center" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-6 bg-play-light-gray" }, null, -1)
const _hoisted_88 = { key: 7 }
const _hoisted_89 = { class: "text-2xl font-medium capitalize" }
const _hoisted_90 = { class: "flex items-center justify-center w-full" }
const _hoisted_91 = {
  for: "dropzone-file",
  class: "flex flex-col items-center justify-center w-full h-64 mt-6 mb-8 border border-gray-500 rounded-lg cursor-pointer bg-play-gray hover:bg-gray-100"
}
const _hoisted_92 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-col items-center justify-center pt-5 pb-6\"><svg xmlns=\"http://www.w3.org/2000/svg\" class=\"w-16 h-16 text-blue-500\" width=\"16\" height=\"16\" fill=\"currentColor\" viewBox=\"0 0 16 16\"><path d=\"M4.98 4a.5.5 0 0 0-.39.188L1.54 8H6a.5.5 0 0 1 .5.5 1.5 1.5 0 1 0 3 0A.5.5 0 0 1 10 8h4.46l-3.05-3.812A.5.5 0 0 0 11.02 4H4.98zm9.954 5H10.45a2.5 2.5 0 0 1-4.9 0H1.066l.32 2.562a.5.5 0 0 0 .497.438h12.234a.5.5 0 0 0 .496-.438L14.933 9zM3.809 3.563A1.5 1.5 0 0 1 4.981 3h6.038a1.5 1.5 0 0 1 1.172.563l3.7 4.625a.5.5 0 0 1 .105.374l-.39 3.124A1.5 1.5 0 0 1 14.117 13H1.883a1.5 1.5 0 0 1-1.489-1.314l-.39-3.124a.5.5 0 0 1 .106-.374l3.7-4.625z\"></path></svg><p class=\"text-lg text-black\">Click here to add a file to upload</p><p class=\"text-center text-gray-600\">Maximum file size 4MB.</p></div>", 1)
const _hoisted_93 = { class: "text-2xl font-medium capitalize" }
const _hoisted_94 = {
  key: 0,
  class: "mt-6 border border-gray-400 rounded"
}
const _hoisted_95 = ["href"]
const _hoisted_96 = ["onClick"]

import { ref } from "vue";
import { useRoute } from "vue-router";

import SubscriptionBadge from "@/components/SubscriptionBadge.vue";
import SubscriptionPanel from "@/components/SubscriptionPanel.vue";
import UserCourses from "@/components/users/UserCourses.vue";
import UserDetails from "@/components/users/UserDetails.vue";
import DefaultButton from "@/components/DefaultButton.vue";
import UserEvents from "@/components/users/UserEvents.vue";
import UserClubs from "@/components/users/UserClubs.vue";
import ReadOnlyNote from "@/components/ReadOnlyNote.vue";
import TimezoneSpan from "@/components/TimezoneSpan.vue";
import TitleHeader from "@/components/TitleHeader.vue";
import TabGroup from "@/components/TabGroup.vue";

import api from "@/api/api";
import { storeToRefs } from "pinia";

import { useGlobalStore, useUserStore } from "@/store";
import { userHasRole } from "@/utils/roles";
import { Booking, User, Organisation, Note, Country, File, Transaction, License } from "@/types";
import PaymentStatusBadge from "@/components/PaymentStatusBadge.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserProfile',
  async setup(__props) {

let __temp: any, __restore: any

const route = useRoute();
const globalStore = useGlobalStore();
const userStore = useUserStore();

const isSavingNote = ref(false);

const allAdmins = ["admin", "users-admin", "courses-admin", "clubs-admin"];

const tabs = [
  {
    id: "user_details",
    name: "User Details",
    roles: ["trainer-organisation", "facilitator-organisation", "l4a-trainer", "l4a-mentor", ...allAdmins],
  },
  {
    id: "orders",
    name: "Orders",
    roles: allAdmins,
  },
  {
    id: "courses",
    name: "Courses",
    roles: ["trainer-organisation", "facilitator-organisation", ...allAdmins],
  },
  {
    id: "events",
    name: "Events",
    roles: ["trainer-organisation", ...allAdmins],
  },
  {
    id: "clubs",
    name: "Clubs",
    roles: ["facilitator-organisation", ...allAdmins],
  },
  {
    id: "subscription",
    name: "Subscription",
    roles: ["trainer-organisation", "facilitator-organisation", ...allAdmins],
  },
  {
    id: "notes",
    name: "Notes",
    roles: allAdmins,
  },
  {
    id: "files",
    name: "Files",
    roles: allAdmins,
  },
];
const selectedTab = ref("user_details");

const user = ref({} as User);
const { user_roles } = storeToRefs(globalStore);
const canDeleteUserValue = ref(false);
const note = ref("");

const notes = ref([] as Note[]);

const licenses = ref([] as License[]);
const bookings = ref([] as Booking[]);
const countries = ref([] as Country[]);
const organisations = ref([] as Organisation[]);

const subscriptions = ref([] as Transaction[]);
const transactions = ref([] as Transaction[]);

const fileInput = ref("");
const files = ref([] as File[]);

countries.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.misc.listCountries())),
  __temp = await __temp,
  __restore(),
  __temp
)).countries;

/** Notes */
async function saveNote() {
  try {
    isSavingNote.value = true;
    const response = await api.users.createUserNote(user.value.id, {
      content: note.value,
    });

    if (response.meta.status === 200) {
      await fetchNotes();
      globalStore.toast("SUCCESS", "Note created");
    } else {
      throw Error();
    }
    note.value = "";
    isSavingNote.value = false;
  } catch (e) {
    console.log("ERROR", e);
    isSavingNote.value = false;
    globalStore.toast("ERROR", "Error creating Note");
  }
}

async function deleteNote(note_id: number) {
  try {
    const response = await api.users.deleteUserNote(user.value.id, note_id);

    if (response.meta.status === 200) {
      await fetchNotes();
      globalStore.toast("SUCCESS", "Note deleted");
    } else {
      throw Error();
    }
  } catch (e) {
    console.log("ERROR", e);
    globalStore.toast("ERROR", "Error deleting Note");
  }
}

async function fetchNotes() {
  notes.value = (await api.users.listUserNotes(user.value.id)).data.notes;
}

/** User Files */
async function listUserFiles() {
  files.value = (await api.users.listUserFiles(user.value.id)).data.files;
}

async function uploadFile(e: any) {
  try {
    if (!e.target.files) return;

    const file = e.target.files[0];

    const form = new FormData();
    form.append("file", file);

    const response = await api.users.uploadUserFile(user.value.id, form);

    if (response.data.id) {
      await listUserFiles();
    }

    return;
  } catch (error) {
    return (fileInput.value = "");
  }
}

async function deleteUserFile(id: number) {
  try {
    await api.users.deleteUserFile(user.value.id, id);

    await listUserFiles();
    globalStore.toast("SUCCESS", "File deleted");
  } catch (error) {
    console.log(error);
    globalStore.toast("ERROR", "Error deleting File");
  }
}

function formatBytes(bytes: number) {
  if (bytes == 0) return "0 Bytes";
  var k = 1024,
    sizes = ["b", "kb", "mb"],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
}

async function fetchSubscriptions() {
  const response = await api.subscriptions.listSubscriptions({
    page: "all",
    user_id: user.value.id,
    sort: "created_at",
    dir: "desc",
  });
  subscriptions.value = response.data.subscriptions;
}

async function fetchOrders() {
  bookings.value = (await api.users.getBookingsByUser(user.value.id)).data.bookings;

  licenses.value = (
    await api.license.listLicenses({
      page: "all",
      user_id: user.value.id,
    })
  ).data.licenses;

  transactions.value = (await api.users.getTransactionsByUser(user.value.id)).data.transactions;
}

async function canDeleteUser() {
  try {
    const response = await api.users.canDeleteUser(user.value.id);
    return response.data.canDelete;
  } catch (e) {
    console.log("ERROR", e);
    globalStore.toast("ERROR", "Error checking if user can be deleted");
    return false;
  }
}

/** Fetch user and make clone of User object to edit */
async function fetchUser() {
  try {
    user.value = (await api.users.getUser(String(route.params.id))).data.user;
  } catch (e) {
    globalStore.toast("ERROR", "Error fetching user");
    window.location.href = "/error";
  }

  if (user.value.job_role === null) {
    user.value.job_role = {
      data: [],
    };
  }

  if (userStore.userIsAdmin) {
    organisations.value = (
      await api.organisations.listOrganisations({
        page: "all",
      })
    ).data.organisations;

    fetchNotes();
    listUserFiles();
    await fetchSubscriptions();
    await fetchOrders();
        // If user is admin admin or courses-admin, check if user can be deleted
    if (userHasRole(user_roles.value, ["admin", "courses-admin"])) {
      canDeleteUserValue.value = await canDeleteUser();
    }
  }
}

;(
  ([__temp,__restore] = _withAsyncContext(() => fetchUser())),
  await __temp,
  __restore()
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(TitleHeader, {
        title: `${user.value.first_name} ${user.value.last_name}`
      }, null, 8, ["title"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", null, [
        _createVNode(SubscriptionBadge, {
          subscription_status: user.value.subscription_status
        }, null, 8, ["subscription_status"])
      ])
    ]),
    _createVNode(TabGroup, {
      tabs: tabs,
      "has-role-guard": true,
      selectedTab: selectedTab.value,
      onSelect: _cache[0] || (_cache[0] = (tab) => selectedTab.value = tab)
    }, null, 8, ["selectedTab"]),
    (selectedTab.value === 'user_details')
      ? (_openBlock(), _createBlock(UserDetails, {
          key: 0,
          user: user.value,
          countries: countries.value,
          organisations: organisations.value,
          canDeleteUser: canDeleteUserValue.value,
          onFetchUser: fetchUser
        }, null, 8, ["user", "countries", "organisations", "canDeleteUser"]))
      : _createCommentVNode("", true),
    (selectedTab.value === 'orders')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t("bookings")), 1),
            _hoisted_7,
            _createElementVNode("table", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bookings.value, (booking) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "border-b border-gray-400 even:bg-gray-200",
                    key: booking.id
                  }, [
                    _createElementVNode("td", _hoisted_10, _toDisplayString(booking.event?.name), 1),
                    _createElementVNode("td", _hoisted_11, _toDisplayString(booking.type), 1),
                    _createElementVNode("td", _hoisted_12, _toDisplayString(booking.event?.type), 1),
                    _createElementVNode("td", _hoisted_13, _toDisplayString(!booking.event?.city ? "Online" : booking.event.city), 1),
                    _createElementVNode("td", _hoisted_14, [
                      _createVNode(TimezoneSpan, {
                        date: booking.event?.first_event_date?.toString(),
                        locale: "en-GB",
                        "date-style": "short",
                        "time-style": "long"
                      }, null, 8, ["date"])
                    ]),
                    (booking.event?.level !== 'Certified Facilitator')
                      ? (_openBlock(), _createElementBlock("td", _hoisted_15, _toDisplayString(booking.event?.owner.first_name) + " " + _toDisplayString(booking.event?.owner.last_name), 1))
                      : (_openBlock(), _createElementBlock("td", _hoisted_16)),
                    (!booking.user_attended)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_17, [
                          _createVNode(PaymentStatusBadge, { order: booking }, null, 8, ["order"])
                        ]))
                      : (_openBlock(), _createElementBlock("td", _hoisted_18, "Completed")),
                    _createElementVNode("td", _hoisted_19, [
                      _createVNode(_component_router_link, {
                        to: `/dashboard/courses/events/${booking.event?.id}/bookings/${booking.id}`,
                        class: "pr-2 text-blue"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("View")
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ])
                  ]))
                }), 128)),
                (!bookings.value.length)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_20, _hoisted_22))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("table", _hoisted_25, [
              _hoisted_26,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(licenses.value, (license) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "border-b border-gray-400 even:bg-gray-200 whitespace-nowrap",
                    key: license.id
                  }, [
                    _createElementVNode("td", _hoisted_27, _toDisplayString(license.id), 1),
                    _createElementVNode("td", _hoisted_28, _toDisplayString(new Date(license.created_at).toDateString()), 1),
                    _createElementVNode("td", _hoisted_29, _toDisplayString(license.organisation.name), 1),
                    _createElementVNode("td", _hoisted_30, _toDisplayString(license.level), 1),
                    _createElementVNode("td", _hoisted_31, _toDisplayString(license.amount), 1),
                    _createElementVNode("td", _hoisted_32, _toDisplayString(license.payment_method === "Invoice" ? _ctx.$t("invoice") : _ctx.$t("credit-debit-card")), 1),
                    _createElementVNode("td", _hoisted_33, [
                      _createElementVNode("span", null, [
                        (license.invoice_issued)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_ctx.$t("yes")), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_ctx.$t("no")), 1))
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_36, [
                      _createElementVNode("span", null, [
                        (license.payment_status === 'complete')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(_ctx.$t("yes")), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(_ctx.$t("no")), 1))
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_39, [
                      _createVNode(_component_router_link, {
                        to: { name: 'Licence', params: { lid: license.id, oid: license.organisation_id } },
                        class: "text-blue"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("View")
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ])
                  ]))
                }), 128)),
                (!licenses.value.length)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_40, _hoisted_42))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _hoisted_44,
            _hoisted_45,
            _createElementVNode("table", _hoisted_46, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_47, [
                  _createElementVNode("th", _hoisted_48, _toDisplayString(_ctx.$t("payment-gateway-order-id")), 1),
                  _createElementVNode("th", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t(`placed`)), 1)
                    ])
                  ]),
                  _createElementVNode("th", _hoisted_51, _toDisplayString(_ctx.$t("type")), 1),
                  _createElementVNode("th", _hoisted_52, _toDisplayString(_ctx.$t("name")), 1),
                  _createElementVNode("th", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t(`organisation`)), 1)
                    ])
                  ]),
                  _createElementVNode("th", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t(`payment-method`)), 1)
                    ])
                  ]),
                  _createElementVNode("th", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t(`status`)), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transactions.value, (transaction) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "border-b border-gray-400 divide-x divide-gray-300",
                    key: transaction.id
                  }, [
                    _createElementVNode("td", _hoisted_59, _toDisplayString(transaction.payment_gateway_ref), 1),
                    _createElementVNode("td", _hoisted_60, _toDisplayString(new Date(transaction.created_at).toDateString()), 1),
                    _createElementVNode("td", _hoisted_61, _toDisplayString(transaction.type === "PaidProfessional" ? "BrickClubBasics" : transaction.type), 1),
                    _createElementVNode("td", _hoisted_62, [
                      _createVNode(_component_router_link, {
                        to: `/dashboard/users/${transaction.user_id}`,
                        class: "text-blue-500"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(transaction.user.first_name) + " " + _toDisplayString(transaction.user.last_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    _createElementVNode("td", _hoisted_63, _toDisplayString(transaction.user.organisation ? transaction.user.organisation.name : ""), 1),
                    _createElementVNode("td", _hoisted_64, _toDisplayString(transaction.payment_gateway), 1),
                    _createElementVNode("td", _hoisted_65, [
                      _createElementVNode("span", null, [
                        (transaction.status === 'Complete')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_66, _toDisplayString(_ctx.$t("yes")), 1))
                          : _createCommentVNode("", true),
                        (transaction.status === 'Pending')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_67, _toDisplayString(_ctx.$t("pending")), 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                }), 128)),
                (!transactions.value.length)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_68, _hoisted_70))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (selectedTab.value === 'courses')
      ? (_openBlock(), _createBlock(UserCourses, {
          key: 2,
          user: user.value
        }, null, 8, ["user"]))
      : _createCommentVNode("", true),
    (selectedTab.value === 'events')
      ? (_openBlock(), _createBlock(UserEvents, {
          key: 3,
          user: user.value
        }, null, 8, ["user"]))
      : _createCommentVNode("", true),
    (selectedTab.value === 'clubs')
      ? (_openBlock(), _createBlock(UserClubs, {
          key: 4,
          user: user.value
        }, null, 8, ["user"]))
      : _createCommentVNode("", true),
    (selectedTab.value === 'subscription')
      ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
          _createVNode(SubscriptionPanel, {
            user: user.value,
            onUpdate: fetchUser
          }, null, 8, ["user"])
        ]))
      : _createCommentVNode("", true),
    (selectedTab.value === 'notes')
      ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
          _createElementVNode("div", _hoisted_73, [
            _hoisted_74,
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((note).value = $event)),
              type: "text",
              class: "block w-full h-24 py-2 text-gray-900 border border-gray-600 rounded md:w-1/2",
              id: "note",
              placeholder: "Your note here..."
            }, null, 512), [
              [_vModelText, note.value]
            ]),
            _createVNode(DefaultButton, {
              onAction: saveNote,
              disabled: isSavingNote.value,
              loading: isSavingNote.value,
              type: "primary",
              class: "mt-4"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Save Note")
              ]),
              _: 1
            }, 8, ["disabled", "loading"]),
            _hoisted_75
          ]),
          _createElementVNode("div", _hoisted_76, [
            _hoisted_77,
            (!notes.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_78, _hoisted_80))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_81, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notes.value, (note) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "flex flex-wrap justify-between w-full px-4 py-2 mt-2 border border-gray-300 rounded md:flex-nowrap",
                  key: note.id
                }, [
                  _createElementVNode("div", _hoisted_82, [
                    _createVNode(ReadOnlyNote, {
                      content: note.content
                    }, null, 8, ["content"]),
                    _createElementVNode("div", _hoisted_83, [
                      _createElementVNode("span", _hoisted_84, "- " + _toDisplayString(note.admin.first_name) + " " + _toDisplayString(note.admin.last_name), 1),
                      _hoisted_85,
                      _createElementVNode("span", null, _toDisplayString(new Date(note.created_at).toLocaleString()), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_86, [
                    _createVNode(DefaultButton, {
                      type: "danger",
                      onAction: ($event: any) => (deleteNote(note.id))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Delete")
                      ]),
                      _: 2
                    }, 1032, ["onAction"])
                  ])
                ]))
              }), 128))
            ]),
            _hoisted_87
          ])
        ]))
      : _createCommentVNode("", true),
    (selectedTab.value === 'files')
      ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
          _createElementVNode("div", null, [
            _createElementVNode("h2", _hoisted_89, _toDisplayString(_ctx.$t("upload-files")), 1),
            _createElementVNode("div", _hoisted_90, [
              _createElementVNode("label", _hoisted_91, [
                _hoisted_92,
                _createElementVNode("input", {
                  id: "dropzone-file",
                  ref_key: "fileInput",
                  ref: fileInput,
                  onChange: uploadFile,
                  type: "file",
                  class: "hidden"
                }, null, 544)
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("h2", _hoisted_93, _toDisplayString(_ctx.$t("files")), 1),
            _createElementVNode("div", null, [
              (files.value.length)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_94, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files.value, (file, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: index,
                        class: "flex items-center justify-between px-4 py-4 even:bg-gray-200"
                      }, [
                        _createElementVNode("a", {
                          class: "text-lg text-blue-500 underline",
                          href: file.file_path
                        }, _toDisplayString(file.name) + " (" + _toDisplayString(formatBytes(file.size)) + ")", 9, _hoisted_95),
                        _createElementVNode("button", {
                          onClick: ($event: any) => (deleteUserFile(file.id)),
                          class: "text-red-500 underline"
                        }, "Delete", 8, _hoisted_96)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})